<app-home-b-hero #hero (onGoToEmployersSectionClick)="hideNavbar()"></app-home-b-hero>
<section class="sections" #sectionContainer id="jeunes">
  <app-navbar-section-home-b
    [initIndex]="navItemIndexSelected$ | async"
    (navigationItemClicked)="onClickedNavItem($event)"
    [navPosition]="navbarPosition$ | async"
  ></app-navbar-section-home-b>
  <app-home-b-section
    *ngFor="let section of sections; trackBy: trackBySection"
    [id]="section.id"
    [accentColor]="section.accentColor"
    [bgColor]="section.bgColor"
    [title]="section.title"
    [icon]="section.icon"
    [cardsList]="section.cardsList"
    #sectionsList
  ></app-home-b-section>
</section>

<app-home-b-news-list></app-home-b-news-list>

<app-home-major-partners></app-home-major-partners>

<app-home-b-employer #employerSection id="employeurs"></app-home-b-employer>

<app-home-b-employer-engagement></app-home-b-employer-engagement>

<app-home-b-companies></app-home-b-companies>
